import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { formatPositionDateTime, getPositionSourceLabel } from '../utils/formatters';

const PosicaoFrotaModal = ({ show, onHide, item, loading, error, posicao }) => (
  <Modal show={show} onHide={onHide} animation={false} size="lg" centered>
    <Modal.Header closeButton>
      <Modal.Title>Posição da frota</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="mb-3 small text-muted d-flex flex-wrap gap-3">
        <span><strong>Frota:</strong> {item?.frota || '-'}</span>
        <span><strong>Placa:</strong> {item?.veiculo || '-'}</span>
        <span><strong>Modelo veicular:</strong> {item?.modeloVeicular || '-'}</span>
        <span><strong>Segmento do veículo:</strong> {item?.segmentoVeiculo || '-'}</span>
        <span><strong>Tipo da operação:</strong> {item?.tipoOperacao || '-'}</span>
        <span><strong>Status:</strong> {item?.disponivelLabel || '-'}</span>
        <span><strong>Status do pátio:</strong> {item?.statusPatioLabel || '-'}</span>
      </div>

      {loading ? (
        <div className="d-flex align-items-center gap-2 text-muted py-4">
          <Spinner animation="border" size="sm" />
          <span>Buscando posição no provedor externo...</span>
        </div>
      ) : null}

      {!loading && error ? (
        <div className="alert alert-warning mb-0">{error}</div>
      ) : null}

      {!loading && posicao ? (
        <>
          <div className="mb-3 small text-muted d-flex flex-wrap gap-3">
            {posicao.cidade ? (
              <span>
                <strong>Local:</strong> {`${posicao.cidade}${posicao.estado ? `/${posicao.estado}` : ''}`}
              </span>
            ) : null}
            {posicao.dataPosicao ? (
              <span>
                <strong>Atualização:</strong> {formatPositionDateTime(posicao.dataPosicao)}
              </span>
            ) : null}
            {posicao.integracao ? (
              <span>
                <strong>Fonte:</strong> {getPositionSourceLabel(posicao.integracao)}
              </span>
            ) : null}
          </div>

          <div className="rounded overflow-hidden shadow-sm w-100" style={{ border: '1px solid #e5e7eb' }}>
            <iframe
              title="google-maps-posicao-frota"
              src={`https://www.google.com/maps?q=${encodeURIComponent(`${posicao.latitude},${posicao.longitude}`)}&z=16&output=embed`}
              width="100%"
              height="360"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </>
      ) : null}
    </Modal.Body>
  </Modal>
);

export default PosicaoFrotaModal;
